import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "../pages/HomePage";

// Admin
import Login from "../admin/pages/Login";
// import MainLayout from "../admin/common/MainLayout";
import Dashboard from "../admin/pages/Dashboard";
import Categories from "../admin/pages/Categories";
import Tags from "../admin/pages/Tags";
import Labels from "../admin/pages/Labels";
import Products from "../admin/pages/Products";
import AddNewProduct from "../admin/pages/AddNewProduct";
import EditProduct from "../admin/pages/EditProduct";
import Coupons from "../admin/pages/Coupons";
import AddCoupons from "../admin/pages/AddCoupons";
import Orders from "../admin/pages/Orders";
import Customers from "../admin/pages/Customers";
import CustomerDetails from "../admin/pages/CustomerDetails";
import CustomerQuestions from "../admin/pages/CustomerQuestions";
import Reviews from "../admin/pages/Reviews";
import Refunds from "../admin/pages/Refunds";
import Subscribers from "../admin/pages/Subscribers";
import EditCoupon from "../admin/pages/EditCoupon";
import ShippingCharges from "../admin/pages/ShippingCharges";
import Blogs from "../admin/pages/Blogs";
import AddBlog from "../admin/pages/AddBlog";
import EditBlog from "../admin/pages/EditBlog";

import Register from "../pages/Register";
import ProfilePage from "../pages/ProfilePage";
import LoginPage from "../pages/LoginPage";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import SubmitOtpPage from "../pages/SubmitOtpPage";
import ResetPasswordPage from "../pages/ResetPasswordPage";
import ContactPage from "../pages/ContactPage";
import AboutPage from "../pages/AboutPage";
import FAQPage from "../pages/FAQPage";
import Termsconditions from "../pages/Termsconditions";
import CustomerRefundPolicyPage from "../pages/CustomerRefundPolicyPage";
import DisclaimerPage from "../pages/DisclaimerPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import AdminMainLayout from "../admin/common/AdminMainLayout";
import MainLayout from "../components/MainLayout";
import CheckoutPage from "../pages/CheckoutPage";
import Subcategories from "../admin/pages/Subcategories";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search]);

  return null;
};

const MyRoutes = () => {
  return (
    <>
      <Router basename={"/"}>
        <ScrollToTop />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <MainLayout>
                <HomePage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/register"
            element={
              <MainLayout>
                <Register />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/login"
            element={
              <MainLayout>
                <LoginPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/forgot-password"
            element={
              <MainLayout>
                <ForgotPasswordPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/submit-otp"
            element={
              <MainLayout>
                <SubmitOtpPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/reset-password"
            element={
              <MainLayout>
                <ResetPasswordPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/profile"
            element={
              <MainLayout>
                <ProfilePage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/about"
            element={
              <MainLayout>
                <AboutPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/contact"
            element={
              <MainLayout>
                <ContactPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/faq"
            element={
              <MainLayout>
                <FAQPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/termsconditions"
            element={
              <MainLayout>
                <Termsconditions />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/customer-refund-policies"
            element={
              <MainLayout>
                <CustomerRefundPolicyPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/disclaimer"
            element={
              <MainLayout>
                <DisclaimerPage />
              </MainLayout>
            }
          />
          <Route
            exact
            path="/privacy-policy"
            element={
              <MainLayout>
                <PrivacyPolicyPage />
              </MainLayout>
            }
          />

          <Route
            exact
            path="/Checkout"
            element={
              <MainLayout>
                <CheckoutPage />
              </MainLayout>
            }
          />

          <Route exact path="/admin/login" element={<Login />} />
          <Route
            exact
            path="/admin/dashboard"
            element={
              <AdminMainLayout title={"Dashboard"}>
                <Dashboard />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/categories"
            element={
              <AdminMainLayout title={"Categories"}>
                <Categories />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/sub-categories"
            element={
              <AdminMainLayout title={"Sub Categories"}>
                <Subcategories />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/tags"
            element={
              <AdminMainLayout title={"Tags"}>
                <Tags />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/labels"
            element={
              <AdminMainLayout title={"Labels"}>
                <Labels />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/products"
            element={
              <AdminMainLayout title={"Products"}>
                <Products />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/add-new-product"
            element={
              <AdminMainLayout title={"Products"}>
                <AddNewProduct />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/editproduct/:id"
            element={
              <AdminMainLayout title={"Products"}>
                <EditProduct />
              </AdminMainLayout>
            }
          />

          <Route
            exact
            path="/admin/coupons"
            element={
              <AdminMainLayout title={"Coupons"}>
                <Coupons />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/add-coupon"
            element={
              <AdminMainLayout title={"Coupons"}>
                <AddCoupons />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/editcoupon/:id"
            element={
              <AdminMainLayout title={"Coupons"}>
                <EditCoupon />
              </AdminMainLayout>
            }
          />

          <Route
            exact
            path="/admin/blogs"
            element={
              <AdminMainLayout title={"Blogs"}>
                <Blogs />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/add-new-blog"
            element={
              <AdminMainLayout title={"Blogs"}>
                <AddBlog />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/editblog/:id"
            element={
              <AdminMainLayout title={"Blogs"}>
                <EditBlog />
              </AdminMainLayout>
            }
          />

          <Route
            exact
            path="/admin/orders"
            element={
              <AdminMainLayout title={"Orders"}>
                <Orders />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/customers"
            element={
              <AdminMainLayout title={"Customers"}>
                <Customers />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/customer-details"
            element={
              <AdminMainLayout title={"Customer Details"}>
                <CustomerDetails />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/customer-details/:customerId"
            element={
              <AdminMainLayout title={"Customer Details"}>
                <CustomerDetails />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/customer-questions"
            element={
              <AdminMainLayout title={"Customer Questions"}>
                <CustomerQuestions />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/reviews"
            element={
              <AdminMainLayout title={"Reviews"}>
                <Reviews />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/refunds"
            element={
              <AdminMainLayout title={"Refunds"}>
                <Refunds />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/subscribers"
            element={
              <AdminMainLayout title={"Newsletter Subscribers"}>
                <Subscribers />
              </AdminMainLayout>
            }
          />
          <Route
            exact
            path="/admin/shipping-charges"
            element={
              <AdminMainLayout title={"Shipping Charges"}>
                <ShippingCharges />
              </AdminMainLayout>
            }
          />
        </Routes>
      </Router>
    </>
  );
};

export default MyRoutes;
